package com.tedd.db

import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.SqlDriver

public class SyncResetQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun markAllDirty() {
    transaction {
      driver.execute(1_318_622_533, """UPDATE user_profile SET synced_at = NULL""", 0)
      driver.execute(1_318_622_534, """UPDATE organization SET synced_at = NULL""", 0)
      driver.execute(1_318_622_535, """UPDATE category SET synced_at = NULL""", 0)
      driver.execute(1_318_622_536, """UPDATE finance_account SET synced_at = NULL""", 0)
      driver.execute(1_318_622_537, """UPDATE finance_category SET synced_at = NULL""", 0)
      driver.execute(1_318_622_538, """UPDATE pomodoro_session SET synced_at = NULL""", 0)
      driver.execute(1_318_622_539, """UPDATE expense_list SET synced_at = NULL""", 0)
      driver.execute(1_318_622_540, """UPDATE focus_session SET synced_at = NULL""", 0)
      driver.execute(1_318_622_541, """UPDATE objective SET synced_at = NULL""", 0)
      driver.execute(1_318_622_542, """UPDATE project SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_358, """UPDATE projectStatus SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_357, """UPDATE milestone SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_356, """UPDATE task SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_355, """UPDATE finance_transaction SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_354, """UPDATE expense_list_item SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_353, """UPDATE pomodoro_item SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_352, """UPDATE pomodoro_check SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_351, """UPDATE notebook SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_350, """UPDATE note SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_349, """UPDATE skill SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_327, """UPDATE parcours_step SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_326, """UPDATE asset SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_325, """UPDATE asset_valuation SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_324, """UPDATE flashcard SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_323, """UPDATE objective_reflection SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_322, """UPDATE craving_observation SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_321, """UPDATE timer_state SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_320, """UPDATE competence_family SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_319, """UPDATE competence SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_318, """UPDATE competence_criterion SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_296, """UPDATE portfolio_piece SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_295, """UPDATE portfolio_piece_competence SET synced_at = NULL""",
          0)
      driver.execute(-2_072_374_294, """UPDATE mind_map SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_293, """UPDATE mind_map_node SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_292, """UPDATE mind_map_node_note SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_291, """UPDATE attachment SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_290, """UPDATE keychain SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_289, """UPDATE keychain_item SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_288, """UPDATE expense_entry SET synced_at = NULL""", 0)
      driver.execute(-2_072_374_287,
          """UPDATE skill_resource SET synced_at = NULL, push_error = NULL""", 0)
      driver.execute(-2_072_374_265,
          """UPDATE assistant_conversation SET synced_at = NULL, push_error = NULL""", 0)
    }
    notifyQueries(479_583_892) { emit ->
      emit("asset")
      emit("asset_valuation")
      emit("assistant_conversation")
      emit("attachment")
      emit("category")
      emit("competence")
      emit("competence_criterion")
      emit("competence_family")
      emit("craving_observation")
      emit("expense_entry")
      emit("expense_list")
      emit("expense_list_item")
      emit("finance_account")
      emit("finance_category")
      emit("finance_transaction")
      emit("flashcard")
      emit("focus_session")
      emit("keychain")
      emit("keychain_item")
      emit("milestone")
      emit("mind_map")
      emit("mind_map_node")
      emit("mind_map_node_note")
      emit("note")
      emit("notebook")
      emit("objective")
      emit("objective_reflection")
      emit("organization")
      emit("parcours_step")
      emit("pomodoro_check")
      emit("pomodoro_item")
      emit("pomodoro_session")
      emit("portfolio_piece")
      emit("portfolio_piece_competence")
      emit("project")
      emit("projectStatus")
      emit("skill")
      emit("skill_resource")
      emit("task")
      emit("timer_state")
      emit("user_profile")
    }
  }
}
